<template lang="pug">
  .xsell-product
    .inner-wrap
      ProductInfoImage(:imagery="product.imagery" primary="standard")

      .text-left
        p.upper.light.color-purple.xs-f-small.max-at-tweak {{ product.productTypeName }}
        p.upper.semi-bold.xs-f-small.max-at-tweak {{ product.name }}
        p.xs-f-small.sm-f-xsmall.md-f-small.max-at-tweak {{ shortDesc }}
        stars(:rating="product.reviews.average")
        p.xs-f-small.max-at-tweak
          span {{ product.price | currency }}

      button.mr-btn.btn-block.xs-f-xsmall.max-at-tweak(:class='{ disabled: addingThisProduct }' @click="addProductToCart")
        i.icon-check-nobox(v-if="addingThisProduct")
          span.ada-tooltip check nobox icon
        span {{ addingThisProduct ? 'Added' : 'Add to Bag' }}
  
</template>

<script>
  import { mapState, mapActions } from "vuex";
  import ProductInfoImage from "../../Dashboard/Purchases/ProductInfoImage";
  export default {
    name: "XsellProduct",
    components: { ProductInfoImage },
    data: () => {
      return {
        addingThisProduct: false
      }
    },

    props: {
      product: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapState('cart', ['addingProduct']),

      shortDesc() {
        let text = null;
        let desc = this.product.desc;

        if (typeof desc == 'string') {
          text = desc;
        } else if (typeof desc == 'object') {
          text = desc.short;
        }

        return text;
      }
    },

    methods: {
      ...mapActions('cart', [
        'addToCart',
        'loadCart'
      ]),

      addProductToCart() {
        if (this.addingProduct) {
          return;
        }

        this.addingThisProduct = true;

        let payload = {
          productId: this.product.id,
          ctaSource: 'Complete Routine Modal',
          cartType: 'active'
        };

        this.addToCart(payload).finally(() => this.loadCart());
      }
    }
  }
</script>

<style scoped lang="stylus">
  .xsell-product
    position relative
    display inline-block
    vertical-align top
    width 18.5em
    height 33em
    padding 1em
    transition(all 400ms 400ms ease-in-out)
    overflow hidden

    .inner-wrap
      position relative
      margin-bottom 2.5em
      padding-bottom 3.5em
      height 30.5em

    .mr-btn
      position absolute
      bottom 0
      left 0
      right 0

</style>
